import { useLingui } from '@lingui/react/macro';

import { InputMultiSelect } from '@/design_system/InputMultiSelect/InputMultiSelect';
import { useBrands } from '@/models/brand';
import { useCurrentOrganization } from '@/services/auth';

export const BrandsMultiSelect = ({
  selectedBrandIds,
  setBrandIds,
  availableBrandIds,
}: {
  selectedBrandIds: string[];
  setBrandIds: (ids: string[]) => void;
  availableBrandIds?: string[];
}) => {
  const { t } = useLingui();
  const [organization] = useCurrentOrganization();
  const { data: { brands: options } = { brands: [] } } = useBrands({
    organizationId: organization?.id,
    limit: 500,
    offset: 0,
  });

  const label = t({ id: 'settings.drawer.brands', message: 'Brands' });

  return (
    <InputMultiSelect
      variant="select"
      label={label}
      placeholder={label}
      value={options.filter((option) => selectedBrandIds.includes(option.id))}
      options={
        availableBrandIds && availableBrandIds.length > 0
          ? options.filter((option) => availableBrandIds?.includes(option.id))
          : options
      }
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.name}
      onChange={(selectedOptions) => setBrandIds(selectedOptions.map((option) => option.id))}
      onRemoveValue={(removedOptionId) =>
        setBrandIds(selectedBrandIds.filter((brandId) => brandId !== removedOptionId))
      }
      isSearchable
    />
  );
};
